import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';
import { isIndividualUser } from '../utils/productAccess';
import './IndividualTrialNotice.scss';

function IndividualTrialNotice({ className = '' }) {
  const { user } = useAppContext();
  const navigate = useNavigate();

  if (!isIndividualUser(user)) {
    return null;
  }

  return (
    <div className={`individual-trial-notice ${className}`.trim()} role="status">
      <p>
        퍼소나 생성 체험은 현재 금융·투자 분야만 지원합니다. 다른 산업/서비스 맞춤 퍼소나는
        {' '}
        <button
          type="button"
          className="individual-trial-notice__inquiry"
          onClick={() => navigate('/inquiry')}
        >
          이용문의
        </button>
        를 통해 안내받으실 수 있습니다.
      </p>
    </div>
  );
}

export default IndividualTrialNotice;
